// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__524F6 {
    font-family: var(--font-primary);
    font-weight: var(--font-medium);
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: var(--font-size-md);
    font-weight: var(--font-semibold);
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

/* Основной стиль (по умолчанию) */
.Button_primary__m9KUo {
    background-color: #FFFFFF;
    color: var(--color-background);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    border: 1px solid #EEEEEE;
}

.Button_primary__m9KUo:hover {
    background-color: var(--color-accent);
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(34, 158, 217, 0.3);
    border-color: transparent;
}

.Button_primary__m9KUo:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(34, 158, 217, 0.2);
}

/* Второстепенный стиль */
.Button_secondary__1YOf\\+ {
    background-color: transparent;
    color: var(--color-accent);
    border: 1px solid var(--color-accent);
}

.Button_secondary__1YOf\\+:hover {
    background-color: rgba(34, 158, 217, 0.1);
    transform: translateY(-2px);
}

/* Стиль для опасных действий */
.Button_danger__tTnUI {
    background-color: #e74c3c;
    color: white;
}

.Button_danger__tTnUI:hover {
    background-color: #c0392b;
}

/* Стиль для кнопки расчета цены */
.Button_calc__RQTSz {
    background-color: var(--color-background);
    color: white;
    padding: 20px 40px;
    border-radius: 8px;
    text-transform: uppercase;
    font-weight: bold;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

.Button_calc__RQTSz:hover {
    background-color: #333333;
    transform: translateY(-3px);
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.3);
}

.Button_calc__RQTSz:active {
    transform: translateY(-1px);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
}

/* Стиль для отключенной кнопки */
.Button_disabled__8uHEx {
    background-color: #cccccc;
    color: #666666;
    cursor: not-allowed;
}

.Button_disabled__8uHEx:hover {
    transform: none;
    box-shadow: none;
} `, "",{"version":3,"sources":["webpack://./src/components/Buttons/Button/Button.module.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;IACjC,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,kCAAkC;AAClC;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,2BAA2B;IAC3B,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA,yBAAyB;AACzB;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kCAAkC;AAClC;IACI,yCAAyC;IACzC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,iCAAiC;AACjC;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".button {\n    font-family: var(--font-primary);\n    font-weight: var(--font-medium);\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: var(--font-size-md);\n    font-weight: var(--font-semibold);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Основной стиль (по умолчанию) */\n.primary {\n    background-color: #FFFFFF;\n    color: var(--color-background);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n    border: 1px solid #EEEEEE;\n}\n\n.primary:hover {\n    background-color: var(--color-accent);\n    color: white;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 10px rgba(34, 158, 217, 0.3);\n    border-color: transparent;\n}\n\n.primary:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(34, 158, 217, 0.2);\n}\n\n/* Второстепенный стиль */\n.secondary {\n    background-color: transparent;\n    color: var(--color-accent);\n    border: 1px solid var(--color-accent);\n}\n\n.secondary:hover {\n    background-color: rgba(34, 158, 217, 0.1);\n    transform: translateY(-2px);\n}\n\n/* Стиль для опасных действий */\n.danger {\n    background-color: #e74c3c;\n    color: white;\n}\n\n.danger:hover {\n    background-color: #c0392b;\n}\n\n/* Стиль для кнопки расчета цены */\n.calc {\n    background-color: var(--color-background);\n    color: white;\n    padding: 20px 40px;\n    border-radius: 8px;\n    text-transform: uppercase;\n    font-weight: bold;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.calc:hover {\n    background-color: #333333;\n    transform: translateY(-3px);\n    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.3);\n}\n\n.calc:active {\n    transform: translateY(-1px);\n    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);\n}\n\n/* Стиль для отключенной кнопки */\n.disabled {\n    background-color: #cccccc;\n    color: #666666;\n    cursor: not-allowed;\n}\n\n.disabled:hover {\n    transform: none;\n    box-shadow: none;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__524F6`,
	"primary": `Button_primary__m9KUo`,
	"secondary": `Button_secondary__1YOf+`,
	"danger": `Button_danger__tTnUI`,
	"calc": `Button_calc__RQTSz`,
	"disabled": `Button_disabled__8uHEx`
};
export default ___CSS_LOADER_EXPORT___;
